import ActionButton from "../atoms/ActionButton";

// YYYYMMDD → YYYY/MM/DD に変換して表示用にする
const formatDateDisplay = (yyyymmdd) =>
  `${yyyymmdd.slice(0, 4)}/${yyyymmdd.slice(4, 6)}/${yyyymmdd.slice(6, 8)}`;

/**
 * RecordUnlockHistoryTable - レコード単位の解除の登録履歴一覧
 *
 * 解除中・再ロック済みの両方を表示する。店舗名・レジ名は RecordUnlock に
 * 保存されていないため regiList から都度ルックアップする。
 *
 * @param {object[]}  recordUnlocks - RecordUnlock の全行
 * @param {object[]}  regiList      - 店舗・レジ一覧（店舗名・レジ名解決用）
 * @param {function}  onRelock      - (id) => void 再ロックボタン押下ハンドラ
 * @param {boolean}   disabled      - 操作中の非活性フラグ
 */
function RecordUnlockHistoryTable({ recordUnlocks, regiList, onRelock, disabled }) {
  const resolveName = (shopNo, regiNo) => {
    const match = regiList.find((r) => r.ShopNo === shopNo && r.RegiNo === regiNo);
    return match ? `${match.ShopName} ${match.RegiName}` : `(店舗No.${shopNo} レジNo.${regiNo})`;
  };

  // 解除日時が新しい順に並べる
  const sorted = [...recordUnlocks].sort((a, b) =>
    (b.UnlockedAt ?? "").localeCompare(a.UnlockedAt ?? ""),
  );

  if (sorted.length === 0) {
    return <p className="text-gray-400 text-base">登録されたレコード単位の解除はありません。</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="border-collapse text-base">
        <thead>
          <tr>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">店舗・レジ</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">対象日付</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">状態</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">解除日時</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">操作者</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap">再ロック日時</th>
            <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-normal whitespace-nowrap"></th>
          </tr>
        </thead>
        <tbody>
          {sorted.map((u) => {
            const isRelocked = u.RelockedAt != null;
            return (
              <tr key={u.id} className="hover:bg-gray-50">
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                  {resolveName(u.ShopNo, u.RegiNo)}
                </td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                  {formatDateDisplay(u.YYYYMMDD)}
                </td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                  {isRelocked ? (
                    <span className="text-gray-400">再ロック済み</span>
                  ) : (
                    <span className="text-red-600 font-medium">解除中</span>
                  )}
                </td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">{u.UnlockedAt}</td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">{u.UnlockedBy}</td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">{u.RelockedAt ?? ""}</td>
                <td className="border border-gray-300 px-3 py-2 whitespace-nowrap">
                  {!isRelocked && (
                    <ActionButton
                      label="再ロック"
                      onClick={() => onRelock(u.id)}
                      disabled={disabled}
                      paddingClass="px-3 py-1"
                      textSizeClass="text-base font-medium"
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default RecordUnlockHistoryTable;
